module.exports = __webpack_public_path__ + "static/media/3.5ae3959a.wav";